document.addEventListener("DOMContentLoaded", function () {
  if (typeof SwatchesConstructor !== "undefined") {
    SwatchesConstructor.prototype.createOptionsView = function (t, e, a, n) {
      var productData = this.getJsonObject();

      if (!productData || !productData.options || !productData.variants) {
        console.error("[Swatches] Product data missing!");
        return;
      }

      var options = productData.options;
      var variants = productData.variants;

      var swatchesHtml = '';
      options.forEach(function (option, index) {
        swatchesHtml += `<div class="tt-title-option">${option.name}</div>`;
        swatchesHtml += `<ul class="custom-swatches" data-option-index="${index}">`;

        option.values.forEach(function (value) {
          var isAvailable = variants.some(function (variant) {
            return (
              variant.available &&
              (variant.option1 === value || variant.option2 === value || variant.option3 === value)
            );
          });
          swatchesHtml += `<li class="custom-swatch ${isAvailable ? '' : 'disabled'}" data-option-value="${value}">${value}</li>`;
        });

        swatchesHtml += '</ul>';
      });

      var container = document.querySelector(t);
      if (!container) { console.error('[Swatches] Container not found:', t); return; }
      container.innerHTML = swatchesHtml;

      var swatches = container.querySelectorAll(".custom-swatch");
      var inputHidden = document.querySelector(".input_variant");
      if (!inputHidden) { console.error('[Swatches] .input_variant not found!'); return; }

      var selectedOptions = new Array(options.length).fill(null);

      function updateAtcButton(variant) {
        var atcButton = document.querySelector('.btn-addtocart');
        if (!atcButton) return;
        if (variant.available) {
          atcButton.classList.remove('disable');
          atcButton.classList.remove('disabled');
          atcButton.removeAttribute('disabled');
          atcButton.innerHTML = window.addtocart_text || '<span class="icon icon-shopping_basket"></span> <span>ADD TO CART</span>';
        } else {
          atcButton.classList.add('disable');
          atcButton.innerHTML = window.unavailable_text || '<span>SOLD OUT</span>';
        }
      }

      function syncStickySelect(variant) {
        var stickySelect = document.querySelector('.tt-fixed-product-wrapper .sticky-variant-select');
        if (!stickySelect) return;
        for (var i = 0; i < stickySelect.options.length; i++) {
          if (parseInt(stickySelect.options[i].value) === variant.id) {
            stickySelect.selectedIndex = i;
            break;
          }
        }
      }

      function fireVariantEvents(variant) {
        inputHidden.value = variant.id;

        if (window.jQuery) {
          window.jQuery(inputHidden).trigger('change');
        } else {
          inputHidden.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (history.replaceState) {
          history.replaceState({}, '', '?variant=' + variant.id);
        }

        var form = document.querySelector('form[action="/cart/add"]');
        if (form) {
          form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
        }

        updateAtcButton(variant);
        syncStickySelect(variant);
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          var optionIndex = parseInt(this.parentElement.getAttribute('data-option-index'));
          var siblingSwatches = this.parentElement.querySelectorAll('.custom-swatch');
          siblingSwatches.forEach((el) => el.classList.remove("active"));
          this.classList.add("active");
          selectedOptions[optionIndex] = this.getAttribute("data-option-value");

          var selectedVariant = variants.find(function (variant) {
            return (
              (!options[0] || variant.option1 === selectedOptions[0]) &&
              (!options[1] || variant.option2 === selectedOptions[1]) &&
              (!options[2] || variant.option3 === selectedOptions[2])
            );
          });

          if (!selectedVariant) selectedVariant = variants[0];
          fireVariantEvents(selectedVariant);
        });
      });

      // Sticky size dropdown: update variant client-side, no page reload
      // Uses class sticky-variant-select (not variant-select) to avoid Wokiee's global reload handler
      var stickySelectEl = document.querySelector('.tt-fixed-product-wrapper .sticky-variant-select');
      if (stickySelectEl) {
        stickySelectEl.addEventListener('change', function () {
          var variantId = parseInt(this.value);
          if (!variantId) return;

          var selectedVariant = variants.find(function (v) { return v.id === variantId; });
          if (!selectedVariant) return;

          // Sync main swatches active state
          options.forEach(function (option, index) {
            var value = selectedVariant['option' + (index + 1)];
            if (!value) return;
            var matchingSwatch = container.querySelector('.custom-swatch[data-option-value="' + value + '"]');
            if (matchingSwatch) {
              var siblings = matchingSwatch.parentElement.querySelectorAll('.custom-swatch');
              siblings.forEach(function (s) { s.classList.remove('active'); });
              matchingSwatch.classList.add('active');
              selectedOptions[index] = value;
            }
          });

          fireVariantEvents(selectedVariant);
        });
      }

      var firstAvailableVariant = variants.find(function (v) { return v.available; }) || variants[0];
      options.forEach(function (option, index) {
        var value = firstAvailableVariant[`option${index + 1}`];
        if (value) {
          var swatch = container.querySelector(`.custom-swatch[data-option-value="${value}"]`);
          if (swatch) { swatch.classList.add('active'); selectedOptions[index] = value; }
        }
      });

      setTimeout(function () { fireVariantEvents(firstAvailableVariant); }, 150);
    };
  } else {
    console.warn("[Swatches] SwatchesConstructor is not defined.");
  }
});
